<app-map-note-modal-view
  [mode]="'popup'"
  [isOpen]="panel()?.noteOpen() ?? false"
  [noteText]="panel()?.noteText() ?? ''"
  [noteSubtitle]="panel()?.noteSubtitle() ?? ''"
  [activeNoteNodeId]="panel()?.activeNoteNodeId() ?? null"
  [closeOnBackdrop]="true"
  (noteDraftChanged)="onNoteDraftChanged($event)"
  (noteFlushRequested)="onNoteFlushRequested($event)"
  (closeRequested)="onCloseRequested()"
/>
